import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { BaasClusterError } from '../../sections/types/BaasClusterError';
import { NodeID } from '../../sections/types/Node';

export interface IDeleteClusterNodeParams {
  nodeId: NodeID;
  clusterId: string;
  siteId: string;
}

export interface IDeleteClusterNodeResult extends IResult {
  success?: {
    nodeId: NodeID;
    displayName?: string;
    status: string;
    clusterId: string;
  };
  siteId?: string;
  error?: BaasClusterError;
}

export class DeleteClusterNodeRequest extends Request<IDeleteClusterNodeParams, IDeleteClusterNodeResult> {
  constructor(params: IDeleteClusterNodeParams) {
    super('deleteClusterNode', params);
  }
}
